<template>
  <div class="insulinUsageStatisticsTable_ctn" :style="style" :class="{ isLongLanguage }">
    <div class="insulinUsageStatisticsTable_titleRow">
      <span>{{ dateRange }} ({{ assessmentTimeDaysNum }} {{ $t('days') }})</span>
      <!-- <span class="insulinUsageStatisticsTable_ctRow-label">{{dateRange}}({{assessmentTimeDaysNum}} {{$t('days')}})</span> -->
      <!-- <span class="insulinUsageStatisticsTable_ctRow-value"> -->
      <!-- <span class="insulinUsageStatisticsTable_titleRow-totalInsulin">{{$t('Total Insulin')}} ({{extra.validInsulinDay}} {{$t('days')}})</span> -->
      <!-- <span class="insulinUsageStatisticsTable_titleRow-totalBasal">{{$t('Carbs')}} ({{carbsValidDays}} {{$t('days')}})</span> -->
      <!-- </span> -->
      <!-- <span class="insulinUsageStatisticsTable_titleRow-days">{{dateRange}}({{assessmentTimeDaysNum}} {{$t('days')}})</span> -->
      <!-- <span class="insulinUsageStatisticsTable_titleRow-totalBolus"></span> -->
    </div>
    <div class="insulinUsageStatisticsTable_ctnRow">
      <span class="insulinUsageStatisticsTable_ctRow-label">{{ $t('Total Insulin') }} (U)</span>
      <span class="insulinUsageStatisticsTable_ctRow-value">{{ totalInsulin }}<span class="unitU"> U</span></span>
    </div>
    <div class="insulinUsageStatisticsTable_ctnRow">
      <span class="insulinUsageStatisticsTable_ctRow-label">{{ $t('Basal') }} (U/%)</span>
      <span class="insulinUsageStatisticsTable_ctRow-value">{{ totalBasal }}<span class="unitU"> U</span> | {{ totalBasalPerdayPercent }} %</span>
    </div>
    <div class="insulinUsageStatisticsTable_ctnRow">
      <span class="insulinUsageStatisticsTable_ctRow-label">{{ $t('Bolus') }} (U/%)</span>
      <span class="insulinUsageStatisticsTable_ctRow-value">{{ totalBolus }}<span class="unitU"> U</span> | {{ totalBolusPerdayPercent }} %</span>
    </div>
    <div class="insulinUsageStatisticsTable_ctnRow">
      <span class="insulinUsageStatisticsTable_ctRow-label">{{ $t('Carbs') }} (g)</span>
      <span class="insulinUsageStatisticsTable_ctRow-value">{{ carbs }}<span class="unitG"> g</span></span>
    </div>
    <div class="insulinUsageStatisticsTable_ctnRow">
      <!-- <span class="insulinUsageStatisticsTable_ctRow-label insulinUsageStatisticsTable_ctRow-label--withOrWithout">{{$t('Bolus Calculator')}}</span> -->
      <span class="insulinUsageStatisticsTable_ctRow-label">{{ $t('Bolus Calculator') }}</span>
      <span class="insulinUsageStatisticsTable_ctRow-value">{{ $t('With') }} {{ extra.withv === undefined ? '-' : extra.withv }} % | {{ $t('Without') }} {{ extra.without === undefined ? '-' : extra.without }} %</span>
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import dayjs from 'dayjs'
import { derrorFactory, errorFactory } from '@u/log'
import { _getMergedPumpBigDosageFromRecords } from '@u/reportHelper'
import { getLocaleDateFormat } from '@/util/dateFormat'
const derror = derrorFactory('InsulinUsageStatisticsTable.vue', false)
const error = errorFactory('InsulinUsageStatisticsTable.vue', true)

function _pretty(_str, fixed = 1) {
  const str = (+_str).toFixed(fixed)
  if (/\.0+$/.test(str)) {
    return (+str).toFixed(0)
  }
  return str
}

let _id = 1
export default {
  name: 'CInsulinUsageStatisticsTable1',
  components: {
    // ChartPie
  },
  mixins: [reDrawTrigger],
  props: {
    extra: {
      type: [Object],
      default: () => {
        return {}
      }
    },
    carbs: {
      type: [Number],
      default: () => 0
    },
    carbsValidDays: {
      type: [Number],
      default: () => 0
    }
  },
  data() {
    _id++
    const id = `insulinUsageStatisticsTable_${+new Date()}_${_id}`
    
    return {
      id
    }
  },
  computed: {
    w() {      
      const { ds } = this
      
      // return ds * (560 / 1740)
      // return ds * (760 / 1740)
      return ds * (500 / 1740)
      // return ds * (1140 / 1740) // 这个才对得起3列。750是2列。但是3列的话右侧放不下了
      // return ds * (1160 / 1740)
    },
    style() {
      const { showMarginRight, zoomRatio, w, isLongLanguage } = this
      const rst = { zoom: zoomRatio, width: `${w}px` }
      
      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }

      if (isLongLanguage) {
        rst.zoom = rst.zoom * 0.81
      }
      return rst
    },
    dateRange() {
      const { extra = {}} = this
      // const { startDate = '', endDate = '' } = extra
      const { startDay, endDay } = this
      // const fmt = 'MM/DD'
      const fmt = getLocaleDateFormat('MM/DD')
      const sstr = startDay ? dayjs(startDay).format(fmt) : '--/--'
      const estr = endDay ? dayjs(endDay).format(fmt) : '--/--'
      
      return `${sstr} - ${estr}`
    },
    totalInsulin() {
      const { extra = {}} = this
      const { totalBasal, totalBolus } = extra
      
      return (+totalBasal + +totalBolus).toFixed(1)
    },
    totalInsulinPerday() {
      const { totalInsulin } = this
      const { extra = {}} = this
      const assessmentTimeDaysNum = extra.validInsulinDay
      
      if (!assessmentTimeDaysNum) {
        return '-'
      }
      
      const num = +totalInsulin
      if (Number.isNaN(num)) {
        return '-'
      } else {
        const rst = (num / assessmentTimeDaysNum).toFixed(1)
        
        return _pretty(rst)
      }
    },
    totalBasal() {
      const { extra = {}} = this
      const { totalBasal = '-' } = extra
      
      return _pretty(totalBasal)
    },
    totalBasalPerday() {
      const { totalBasal } = this
      const { extra = {}} = this
      const assessmentTimeDaysNum = extra.validInsulinDay
      
      if (!assessmentTimeDaysNum) {
        return '-'
      }
      const num = +totalBasal
      if (Number.isNaN(num)) {
        return '-'
      } else {
        const rst = (num / assessmentTimeDaysNum).toFixed(1)
        
        return _pretty(rst)
      }
    },
    totalBasalPerdayPercent() {
      const d = '-'
      const { totalBasal, totalBolus } = this
      const totalBasalNum = +totalBasal
      const totalBolusNum = +totalBolus
      
      if (Number.isNaN(totalBasalNum) || Number.isNaN(totalBolusNum)) {
        return d
      }
      const total = totalBasalNum + totalBolusNum
      
      if (totalBasalNum + totalBolusNum === 0) {
        return d
      }
      
      const rst = (totalBasalNum / total * 100).toFixed(1)
      
      return _pretty(rst)
    },
    totalBolus() {
      const { extra = {}} = this
      const { totalBolus = '-' } = extra
      
      return _pretty(totalBolus)
    },
    totalBolusPerday() {
      const d = '-'
      const { totalBolus } = this
      const { extra = {}} = this
      const assessmentTimeDaysNum = extra.validInsulinDay
      
      if (!assessmentTimeDaysNum || String(assessmentTimeDaysNum) === '0') {
        return d
      }
      const num = +totalBolus
      if (Number.isNaN(num)) {
        return d
      } else {
        const rst = (num / assessmentTimeDaysNum).toFixed(1)
        
        return _pretty(rst)
      }
    },
    totalBolusPerdayPercent() {
      const d = '-'
      const { totalBasal, totalBolus } = this
      const totalBasalNum = +totalBasal
      const totalBolusNum = +totalBolus
      
      if (Number.isNaN(totalBasalNum) || Number.isNaN(totalBolusNum)) {
        return d
      }
      const total = totalBasalNum + totalBolusNum 
      if (String(total) === '0') {
        return d
      }

      const rst = (totalBolusNum / total * 100).toFixed(1)

      return _pretty(rst)
    },
    carbsPerday() {
      const num = +this.carbs
      const days = this.carbsValidDays
      
      if (Number.isNaN(num) || !days) {
        return '-'
      } else {
        const rst = (num / days).toFixed(1)

        return _pretty(rst)
      }
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';

$rowH: 40px;
$s-w-indent: 20px;
$s-w-indent-smaller: 10px;
.insulinUsageStatisticsTable_ctn {
    margin-right: 30px;
    background-color: $colorGluMesurementLabelBg;
    color: $colorGluMesurementFont;
    border-radius: 4px;
    overflow: hidden;
    @include bBox;
    color: #000000;
    font-weight: 600;
    font-size: 16px;
    border: 1px solid $colorGluMesurementInnerBorder;    
    
    .insulinUsageStatisticsTable_titleRow, .insulinUsageStatisticsTable_ctnRow {
        height: $rowH;
        text-indent: $s-w-indent;
        border-bottom: 1px solid $colorGluMesurementInnerBorder;
    }
    .insulinUsageStatisticsTable_titleRow {
        background-color: white;
        @include flexRow(space-between, center);
        > span {
            text-align: left;
            display: inline-block;
            /* width: 24.6%; */
            /* &:first-child { */
            /*     width: 25%; */
            /* } */
            /* &:last-child { */
            /*     width: 25%; */
            /* } */
            /* &.insulinUsageStatisticsTable_ctRow-label { */
            /*     width: (271 / 751) * 100%; */
            /* } */
            /* &.insulinUsageStatisticsTable_ctRow-value { */
            /*     background: initial; */
            /* } */
        }
        
        .insulinUsageStatisticsTable_titleRow-totalBolus {
            flex-grow: 1;
            flex-shrink: 1;
        }
        .insulinUsageStatisticsTable_titleRow-totalBasal {
            margin-left: 6em;
        }
    }
    
    .insulinUsageStatisticsTable_ctnRow {
        @include flexRow(flex-start, center);
        &:last-child {
            border-bottom: none;
        }
        > * {
        }
    }
    .insulinUsageStatisticsTable_ctRow-label {
        /* width: (271 / 751) * 100%; */
        width: 50%;
        &.insulinUsageStatisticsTable_ctRow-label--2 {
            width: (221 / 751) * 100%;            
        }
        &.insulinUsageStatisticsTable_ctRow-label--withOrWithout {
            width: (180 / 420) * 100%;
        }
    }
    .insulinUsageStatisticsTable_ctRow-value {
        text-indent: $s-w-indent;
        background: white;
        flex: 1;
        @include heightMiddle($rowH);
        font-weight: normal;
    }
    .unitU {
        position: relative;
        top: 1px;
    }
    .unitG {
        position: relative;
        top: 1px;
    }
    
    &.isLongLanguage {
        .insulinUsageStatisticsTable_titleRow, .insulinUsageStatisticsTable_ctnRow {
            text-indent: $s-w-indent-smaller;
        }
        .insulinUsageStatisticsTable_ctRow-label {
            /* width: (271 / 751) * 100%; */
            width: 60%;
            &.insulinUsageStatisticsTable_ctRow-label--2 {
                width: (221 / 751) * 100%;            
            }
            &.insulinUsageStatisticsTable_ctRow-label--withOrWithout {
                width: (210 / 420) * 100%;
            }
        }
    }
}
</style>
